import React from 'react'

export const SimplePracticeIcon: React.FC<{
  width?: string | number
  height?: string | number
}> = ({ width = '25', height = '25' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
    role="img"
    aria-label="SimplePractice Icon"
  >
    <rect x="2.75" y="2.69043" width="20" height="20" rx="2" fill="#FFC600" />
    <path
      d="M14.044 7.41123C12.3923 8.30741 11.4789 10.1418 12.3889 12.4866C13.2282 14.6493 15.1781 17.1879 15.2042 17.2143L7.44883 12.6704C7.2425 12.5496 6.97716 12.6474 6.89883 12.8756C6.31804 14.5666 7.46966 16.9996 9.78482 18.356C10.2266 18.6148 10.6955 18.8184 11.1723 18.9661C13.4339 19.6665 15.8551 18.5331 16.8288 16.3465L19.4904 10.3703C19.8359 9.59219 19.8489 8.68451 19.4547 7.93399C18.5559 6.22448 16.2354 6.65703 14.9867 7.02892C14.65 7.12925 14.3303 7.25684 14.044 7.41123Z"
      fill="white"
    />
  </svg>
)
